import React from 'react'

// react meta tags
import { ReactTitle } from "react-meta-tags";

// react redux
import { connect } from "react-redux";

// themes
import Theme1 from './Themes/AccountSettingsTheme1/AccountSettings'

function AccountSettings(props) {
    // props
    const {
        globalAppTheme,
    } = props

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Your Account | krave Decor"} />

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 parentProps={props} />
                ) : null
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: param => dispatch(func(param)),
//     };
// };

export default connect(getDataFromStore, null)(AccountSettings);